import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { AdminService } from '../../services/admin.service';
import { MasterDTO } from '../../model/admin.entity';
import { CommonService } from '../../../core/common/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { Dropdown } from 'primeng/dropdown';
import { TestTypeDTO } from '../../model/test-type.entity';
import { Router } from '@angular/router';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';

@Component({
  selector: 'tandc-test-type',
  templateUrl: './test-type.component.html',

})
export class TestTypeComponent implements OnInit {

  testTypeList: TestTypeDTO[] = [];
  model: TestTypeDTO = new TestTypeDTO();
  standardList: Dropdown[] = [];
  showModal: boolean = false;
  modalTitle: string = "";
  @ViewChild('dt')
  dt!: Table;

  constructor(private service: AdminService,
    private commonService: CommonService,
    private translate: TranslateService,
    private router: Router,
   private masterDataRepository: MasterDataRepository) { }

  ngOnInit(): void {
    this.getAll();
  }


  applyFilterGlobal($event: any, stringVal: any) {
    this.dt!.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  getAll() {
    this.service.getTestType().subscribe((x) => {
      this.testTypeList = x.value;
    });
  }

  addModal() {
    this.router.navigate(['admin/testTypeStandard']);
    this.model = new TestTypeDTO();
    // this.showModal = !this.showModal;
    this.translate.instant('commonbtn.add') +
      ' ' +
      this.translate.instant('test.typelbl');

  }

  delete(data: TestTypeDTO) {
    this.commonService.confirmationService.confirm({
      message: this.translate.instant('Alerts.DeleteConfirmation'),
      accept: () => {
        if (data) {
          this.service.deleteTstType(data.id).subscribe((res) => {
            if (res) {
              this.commonService.successMessage(
                this.translate.instant('Alerts.DeleteSuccessfully')
              );
              this.getAll();
            }
          });
        }
      },
    });
  }

  onToggleStatus(item: TestTypeDTO) {
  const updatedItem = { ...item }; 
  this.service.updateTstType(updatedItem).subscribe({
    next: () => {
      this.commonService.successMessage(
        this.translate.instant('Alerts.UpdatedSuccessfully')
      );
    },
    error: () => {
      this.commonService.errorMessage(
        this.translate.instant('Alerts.ErrorOccured')
      );
      // Revert toggle on error
      item.isActive = !item.isActive;
    }
  });
  }

  edit(data: TestTypeDTO) {
    this.router.navigate(['admin/testTypeStandard', data.id]);
    this.modalTitle = this.translate.instant('common.update') + ' ' + this.translate.instant('test.typelbl');
    this.model = data;
    //this.showModal = !this.showModal;
  }

        downloadFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  export() {
    this.masterDataRepository.export('test-type').subscribe(blob => {
      this.downloadFile(blob, `test-type-${new Date().toISOString().slice(0,10)}.xlsx`);
    });
  }


}
